export enum AgeCategory {
    ALL_AGES = 'All Ages',
    ADULT = 'Adult',
    YOUNG_ADULT = 'Young Adult',
    CHILDREN = 'Children'
}
